import { type Clip } from '@air/api/types';

import { isAssetComparisonClipEligible } from '~/utils/isAssetComparisonClipEligible';

export const COMPARABLE_SELECTION_SIZE = 2;

export type ComparableClip = Pick<Clip, 'assets' | 'ext' | 'status' | 'type'>;

export type CanCompareSelectionParams = {
  hasSelectionAcrossMultipleViews: boolean;
  isSelectAllActive: boolean;
  selectedItemCount: number;
  selectedMediaClips: ComparableClip[];
};

/** Shared visibility rule for every compare-selection entry point. */
export const canCompareSelection = ({
  hasSelectionAcrossMultipleViews,
  isSelectAllActive,
  selectedItemCount,
  selectedMediaClips,
}: CanCompareSelectionParams) =>
  !isSelectAllActive &&
  !hasSelectionAcrossMultipleViews &&
  selectedItemCount === COMPARABLE_SELECTION_SIZE &&
  selectedMediaClips.length === COMPARABLE_SELECTION_SIZE &&
  selectedMediaClips.every(isAssetComparisonClipEligible);
